<template>
  <md-card
    class="time-zone pt-2"
    :class="{ hidden: isHiddenCard }"
    v-click-outside="closeModal"
  >
    <md-card-header>
      <div class="modal-header justify-between items-start p-0">
        <p v-if="!hasTimezone">{{ $t("timezone.your_computers_timezone") }}</p>
        <p v-else class="font-medium">{{ $t("timezone.current_timezone") }}:</p>
        <button
          class="close-btn ml-6 text-red-600"
          @click="isHiddenCard = true"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-content pt-4" v-if="hasTimezone">
        <p>{{ info.reference.timezone }}</p>
      </div>
    </md-card-header>
    <md-card-content class="py-0">
      <isis-autocomplete
        v-model="timezoneDisplay"
        :value.sync="timezone"
        :options="timeZoneOpts"
        label="timezone.timezone"
      >
      </isis-autocomplete>
    </md-card-content>
  </md-card>
</template>
<script>
import { TIMEZONE_OPTION } from "@/constants/Timezone";
import { mapState, mapMutations } from "vuex";
import { getId } from "@/helpers/utils";
import { service_names } from "@/constants/Services";

export default {
  data() {
    return {
      timezoneDisplay: "",
      timezone: "",
      timeZoneOpts: TIMEZONE_OPTION,
      isHiddenCard: false
    };
  },
  computed: {
    ...mapState("user", ["info"]),
    hasTimezone() {
      return this.info?.reference?.timezone;
    }
  },
  watch: {
    timezone: function(newVal, oldVal) {
      this.selectTimezone(newVal);
    }
  },
  methods: {
    ...mapMutations("user", ["setTimezone"]),
    selectTimezone(timezone) {
      if (!timezone) return;
      const path = `${service_names.user}/user/${getId(this.info)}/timezone`;
      this.$axios
        .put(path, { timezone: timezone })
        .then(() => {
          this.setTimezone(timezone);
          this.isHiddenCard = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    closeModal() {
      this.isHiddenCard = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.time-zone {
  width: 300px;
  position: fixed;
  right: 80px;
  z-index: 1032;
  border-radius: 10px;
  top: 40px;
  box-shadow: gray;

  @media screen and (max-width: 599px) {
    width: 70%;
  }
}
.md-card {
  z-index: 1032;
  height: 170px;
}
</style>
